"use client";

import React from "react";
import { motion } from "framer-motion";
import { MapPin, MessageCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Link } from "@/components/common/Link";
const serviceZones = [{
  name: "Totana",
  path: "/TotanaPage"
}, {
  name: "Murcia",
  path: "/MurciaPage"
}, {
  name: "Alicante",
  path: "/AlicantePage"
}, {
  name: "Almería",
  path: "/AlmeriaPage"
}];
export default function ServiceZones() {
  return <section id="servicezones" className="bg-background py-16 md:py-24 relative overflow-hidden">
      <div className="container mx-auto px-4 md:px-8 max-w-4xl text-center">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="flex flex-col items-center max-w-3xl mx-auto">
          <Badge variant="outline" className="mb-4 px-3 py-1 text-xs font-medium uppercase tracking-wider border-primary/30 text-primary">
            <MapPin className="size-3.5 mr-1" />
            Áreas de Cobertura
          </Badge>
          
          <h2 className="font-mono text-2xl sm:text-3xl md:text-4xl font-bold uppercase tracking-tight text-primary mb-8 leading-tight">
            Damos servicio técnico en toda la provincia de Murcia, Alicante y Almería.
          </h2>

          <div className="flex flex-wrap items-center justify-center gap-3 sm:gap-4 mb-10">
            {serviceZones.map((zone, i) => <Link data-index={i} key={zone.name} to={zone.path} className="px-5 py-2.5 rounded-lg border border-border bg-card text-foreground hover:text-primary hover:border-primary/50 transition-all font-mono text-sm sm:text-base font-semibold shadow-xs">
                {zone.name}
              </Link>)}
          </div>

          <div>
            <Button asChild size="lg" className="bg-[#25D366] hover:bg-[#20bd5a] text-white font-medium shadow-md px-8 rounded-lg">
              <Link to="https://wa.me/34657068444" newTab>
                <MessageCircle className="size-5 mr-2" />
                Escríbenos por WhatsApp
              </Link>
            </Button>
          </div>
        </motion.div>
      </div>
    </section>;
}